export enum SsoProvider {
  GOOGLE = 'google.com',
  MICROSOFT = 'microsoft.com',
}
